module.exports = __webpack_public_path__ + "img/EditActionGrey.d54b129e.svg";